import { useMsg } from '~/common/localizationUtils'
import { ClientOnly } from '~/common/nextJsUtils'
import { IconButton, IconButtonProps } from '~/design_system'
import { Filter } from '~/icons'
import { useActionBarContext } from './ActionBar.hook'

export const ToggleFiltersButton = (props: Omit<IconButtonProps, 'aria-label'>) => {
  const { onToggle } = useActionBarContext()?.filtersDisclosure ?? {}
  const msg = useMsg()

  if (onToggle === undefined && props.onClick === undefined) return null

  return (
    <ClientOnly>
      <IconButton
        data-action-bar-toggle-filters
        display={{ base: 'flex', lg: 'none' }}
        size="md"
        icon={<Filter />}
        variant="secondary"
        onClick={onToggle}
        showTooltip
        {...props}
        aria-label={msg('common.action_bar.toggle_filters_button')}
      />
    </ClientOnly>
  )
}
